export default __webpack_public_path__ + "static/media/doctor.d6443325.svg";